import { createApiInstance, API_CONFIG } from './config'

const api = createApiInstance({
  ...API_CONFIG,
  timeout: 180000
})

export const answerTestAPI = {
  chat(data) {
    return api.post('/answer-test/chat', data)
  }
}

export default answerTestAPI
